import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountLoginComponent } from '@app/account/account-login/account-login.component';
import { PublicRoutes } from '@shared/common/routing/public-routes';
import { AccountForgotPasswordComponent } from '@app/account/account-forgot-password/account-forgot-password.component';

const routes: Routes = [
  {
    path: PublicRoutes.ACCOUNT.login.localPath,
    component: AccountLoginComponent,
    data: {title: PublicRoutes.ACCOUNT.login.localeKey}
  },
  {
    path: PublicRoutes.ACCOUNT.forgotPassword.localPath,
    component: AccountForgotPasswordComponent,
    data: {title: PublicRoutes.ACCOUNT.forgotPassword.localeKey}
  },
  {
    path: PublicRoutes.ACCOUNT.resetPassword.localPath,
    component: AccountForgotPasswordComponent,
    data: {title: PublicRoutes.ACCOUNT.resetPassword.localeKey}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {
}
